import React, { useState, useMemo } from 'react';
import './ProductHighlightsModal.scss';
import LKModal from '../../../../desktop/components/Modal/Modal';
import { useSelector } from 'react-redux';
import ButtonOwnDays from '../../../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';
import { v4 } from 'uuid';
import { capitalizeLetters } from '../../../helper';

const ProductServiceHighlights = ({ showHighlightsModal, setShowHighlightsModal }) => {
  const dataLocale = useSelector(state => state.locale);
  const { FREE_SHIPPING, ONE_YEAR_WARRANTY_PDP = 'One-year warranty', EARN, POINTS } = dataLocale;

  const [activeTab, setActiveTab] = useState('freeShipping');

  const tabs = useMemo(() => {
    return [
      {
        name: capitalizeLetters(FREE_SHIPPING.toLowerCase(), true),
        switcher: 'freeShipping',
        description: 'We provide free shipping to your doorstep in 3-5 days.',
      },
      {
        name: ONE_YEAR_WARRANTY_PDP,
        switcher: 'oneYearWarranty',
        description:
          'We provide a one-time complimentary change of lens degree if you experience discomfort in your vision within the first year of purchase.',
        button: {
          buttonLabel: 'View all warranty details',
          href: '/sg/en/services/warranty',
        },
      },
      {
        name: `${EARN} ${POINTS}`,
        switcher: 'earnPoints',
        description:
          'Earn membership points to offset your next online or in-store purchase. No membership fee required.',
        button: {
          buttonLabel: 'How do membership points work?',
          href: '/sg/en/account',
        },
      },
    ];
  }, [EARN, FREE_SHIPPING, ONE_YEAR_WARRANTY_PDP, POINTS]);

  const activeTabData = useMemo(() => {
    return tabs.find(tab => tab.switcher === activeTab);
  }, [activeTab, tabs]);

  const close = () => {
    setShowHighlightsModal(false);
  };

  const mainClass = 'od-highlights-modal';

  return (
    <LKModal
      backdrop
      keyboard
      dialogClassName="od-highlights-modal-wrapper"
      hideHandler={close}
      outSideContentClick={close}
      showModal={showHighlightsModal}
    >
      <div className={`${mainClass}`}>
        <div className={`${mainClass}__header`}>
          <div className={`${mainClass}__header__tabs`}>
            {tabs.map(tab => {
              return (
                <ButtonOwnDays
                  key={v4()}
                  borderless
                  classes={`${mainClass}__header__tabs__tab`}
                  fontClass="od-font-bold"
                  fontSize="16px"
                  mode={tab.switcher === activeTab ? 'grey' : 'grey-tertiary'}
                  px="24px"
                  py="11px"
                  text={tab.name}
                  width="auto"
                  onClick={() => setActiveTab(tab.switcher)}
                />
              );
            })}
          </div>
        </div>
        <div className={`${mainClass}__content`}>
          <div className={`${mainClass}__content__description od-font-reg`}>
            {activeTabData.description}
          </div>
          {activeTabData.button && (
            <div className={`${mainClass}__content__button od-font-bold`}>
              <a href={activeTabData.button.href}>{activeTabData.button.buttonLabel}</a>
            </div>
          )}
        </div>
      </div>
    </LKModal>
  );
};

export default ProductServiceHighlights;
